import { inject, Pipe, type PipeTransform } from '@angular/core';
import { LocaleService } from '@selfcare/cms';
import dayjs from 'dayjs';

@Pipe({
  name: 'scDate',
  standalone: true,
  pure: false,
})
export class DateFormatPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  public transform(value: string | number | Date, format = 'DD-MM-YYYY'): string {
    if (!value || value === 'N/A') {
      return 'N/A';
    }
    const locale = this.localeService.currentLocale;
    return dayjs(value).locale(locale).format(format);
  }
}
